import {
  InputBase,
  // FormHelperText
} from "@mui/material";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

RHFLoginTextField.propTypes = {
  name: PropTypes.string.isRequired,
  sx: PropTypes.object,
  placeholder: PropTypes.string,
};

export default function RHFLoginTextField({
  name,
  sx,
  placeholder,
  ...other
}) {
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <InputBase
            {...field}
            fullWidth
            error={!!error}
            placeholder={t(placeholder)}
            {...other}
            required
            sx={{
              width: "100%",
              // ── ROOT (the whole input) ───────────────────────
              "& .MuiInputBase-input": {
                // Text colour - white text as shown in the image
                color: "#FFFFFF",

                // Placeholder colour - lighter white/gray
                "&::placeholder": {
                  color: "rgba(255, 255, 255, 0.7)",
                  opacity: 1,
                },

                // ── AUTOFILL (Chrome / Safari / Edge) ───────
                "&:-webkit-autofill": {
                  // Semi-transparent white background for autofill
                  WebkitBoxShadow: "0 0 0 1000px rgba(255, 255, 255, 0.15) inset !important",
                  WebkitTextFillColor: "#FFFFFF !important",
                  caretColor: "#FFFFFF !important",
                  backgroundColor: "rgba(255, 255, 255, 0.15) !important",
                  borderRadius: "inherit",
                  transition: "background-color 5000s ease-in-out 0s",
                },
                "&:-webkit-autofill:hover": {
                  WebkitBoxShadow: "0 0 0 1000px rgba(255, 255, 255, 0.2) inset !important",
                },
                "&:-webkit-autofill:focus": {
                  WebkitBoxShadow: "0 0 0 1000px rgba(255, 255, 255, 0.2) inset !important",
                },

                // Firefox
                "&:autofill": {
                  backgroundColor: "rgba(255, 255, 255, 0.15) !important",
                  color: "#FFFFFF !important",
                },

                // Selection highlight
                "&::selection": {
                  backgroundColor: "rgba(255, 255, 255, 0.3)",
                },
              },

              // ── CONTAINER (background + border) ───────────────
              // Very subtle transparent white background (15% opacity)
              backgroundColor: "rgba(255, 255, 255, 0.15)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              borderRadius: 1,
              px: "18px",
              py: "4px",
              backdropFilter: "blur(0.6px)", // Optional: adds glass effect

              // ── HOVER EFFECT ──────────────────────────────────
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.2)",
                borderColor: "rgba(255, 255, 255, 0.4)",
              },

              // ── FOCUS ───────────────────────────────────────
              "&.Mui-focused": {
                backgroundColor: "rgba(255, 255, 255, 0.25)",
                borderColor: "rgba(255, 255, 255, 0.6)",
                borderWidth: "1px",
                outline: "none",
              },

              ...sx,
            }}
          />
        </>
      )}
    />
  );
}